import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormBuilder, Validators } from '@angular/forms';
import { APIHeaderService } from '../../_services/header/API-header';
import { Router, ActivatedRoute } from '@angular/router';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalPromptComponent } from '../../../../_helpers/Modals/prompt/modal.prompt';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-header-suspension',
  templateUrl: './header-suspension.component.html',
  styleUrls: ['./header-suspension.component.css']
})
export class HeaderSuspensionComponent implements OnInit {
  headerSuspForm: FormGroup;
  headerID: any;
  HeaderDetails: any;
  cli: any;
  filterData: any;
  modalRef: any;
  htyp: any;
  urn: any;
  customerAff: boolean = false;
  customerAffErr : boolean =false;
 

  constructor(private fb: FormBuilder,
    private hs: APIHeaderService,
    private _route: ActivatedRoute,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private router: Router,
    private modalService: BsModalService) { }
  get f() { return this.headerSuspForm.controls; }
  displayInfo: boolean = false;
  displayRevoke: boolean = false;
  displaySuspend: boolean = false;
  temporary: boolean = false;
  crtr: boolean = false;
  offset: any;

  public hdervalidity = [
    { value: "15", viewValue: "15" },
    { value: "30", viewValue: "30" },
    { value: "45", viewValue: "45" },
    { value: "60", viewValue: "60" },

  ]

  ngOnInit() {
    this.headerSuspForm = this.fb.group({
      // hname: [''],
      hname: ['', [Validators.required, Validators.pattern("^([a-zA-Z0-9]{3,6})$"), Validators.minLength(3), Validators.maxLength(6)]],
      validityTill: [''],
      status: [''],
      hclass: [''],
      validity: ['',],
      hid: [''],
      suspdate: [''],
      validityDays: [''],
      description: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(400),Validators.pattern(/(^(?![0-9\s]*$)[a-zA-Z0-9 ,.\s]+$)/)]],
    })
    this.offset = new Date().getTimezoneOffset();
    this._route.params.subscribe((params) => {
      this.headerID = params['urn'];
      console.log("The Hid is", this.headerID)
      if(this.headerID){
         this.fetchHeaderDetails()
      }
    })


  }

  onSubmit() {
    console.log(" in ")


  }

  fetchHeaderDetails() {
    let data = {}
    if(this.headerID){
      data = {
        peid: this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID),
        sts: { $in: ["A", "SC", "SU", "SV"] },
        urn: this.headerID
      }
    }
    else{
      data = {
        peid: this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID),
        sts: { $in: ["A", "SC", "SU", "SV"] },
        cli: this.headerSuspForm.controls['hname'].value
      }
    }
    
    console.log(data)
    this.hs.headersbype(data)
      .subscribe(r => {
        if (r.data.length > 0) {
          this.headerSuspForm.get('description').markAsTouched();
          if(this.headerID){
             this.headerSuspForm.controls['hname'].setValue(r.data[0].cli);
          }
          this.displayInfo = true;
          this.temporary = false;
             
          this.filterData = r.data;
          if(r.data[0].crtr == "tata.com"){
            this.crtr = true
          }
          if (r.data[0].sts == "A") {
            this.headerSuspForm.controls['status'].setValue("Active");
            // this.displaySuspend = true
            // this.displayRevoke = false;
          }  
          else if (r.data[0].sts == "SC")
            this.headerSuspForm.controls['status'].setValue("Suspended By customer");
          else if (r.data[0].sts == "SU")
            this.headerSuspForm.controls['status'].setValue("Suspended as Unused");
          else if (r.data[0].sts == "SV" && r.data[0].hclass == "Permanent")
            this.headerSuspForm.controls['status'].setValue("Suspended due to Verification");
          else if (r.data[0].sts == "SV" && r.data[0].hclass == "Temporary")
            this.headerSuspForm.controls['status'].setValue("Suspended as Validity expired");
          else
            this.headerSuspForm.controls['status'].setValue(r.data[0].sts);

          if(r.data[0].sts == "SV" || r.data[0].sts == "SU"){
            this.customerAff = true;
            this.customerAffErr = true;
          }
          if (r.data[0].hclass == "Permanent") {
            this.headerSuspForm.controls['validityTill'].setValue(r.data[0].hdrVerificationdate_CC);
          }
          else {
            this.headerSuspForm.controls['validityTill'].setValue(r.data[0].hdrValidityTill);
          }

          this.headerSuspForm.controls['hclass'].setValue(r.data[0].hclass);
          this.headerSuspForm.controls['hid'].setValue(r.data[0].hid);
          this.htyp = r.data[0].htyp;
          this.urn = r.data[0].urn;
          if (r.data[0].gsts == "SC" || r.data[0].gsts == "SV" || r.data[0].gsts == "SU") {
            this.displaySuspend = false;
            this.displayRevoke = true;
            this.headerSuspForm.controls['suspdate'].setValue(r.data[0].suspensionDate_CC);
          }
          else if (r.data[0].gsts == "A" && r.data[0].hclass == "Permanent") {
            this.displaySuspend = true
            this.displayRevoke = false;
            this.headerSuspForm.controls['suspdate'].setValue("NA");
          }
          if(r.data[0].hclass == "Temporary"){
              this.temporary = true;
              this.displaySuspend = false;   
          }

        }
        else {
          this.displayInfo = false;
          this.displayRevoke = false;

          this.$modal.errorModal({
            title: 'Header Suspension/ Revocation',
            msg: "Header not found"
          });
        }
      })

  }
  suspendHeader() {
    
    if(this.headerSuspForm.invalid){
      //this.desc = true;
      return
   }
   else{
    this.modalRef = this.modalService.show(ModalPromptComponent);
    this.modalRef.content.modalDataObj = {
      title: "Header Suspension",
      msg: "Are you sure you want to suspend the header. Do you want to continue?",

    }
    if(this.crtr == false){
      this.$modal.errorModal({
        title: 'Header Suspension/ Revocation',
        msg: "Only creator operator can suspend or revoke the header"
      });
      return
    }
    this.modalRef.content.onClose.subscribe(result => {
      if (result === true) {
        let data = {
          cli: this.headerSuspForm.controls['hname'].value,
          // sts: this.headerSuspForm.controls['status'].value,
          sts: "SC",
          hid: this.headerSuspForm.controls['hid'].value,
          hclass: this.headerSuspForm.controls['hclass'].value,
          peid: this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID),
          reason:this.headerSuspForm.controls['description'].value,
          htype: this.htyp,
          urn: this.urn,
          orgname: this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME),    
          Email: this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID)
        }
        this.hs.suspendHeaderByPE(data)
          .subscribe(r => {
            if (r.status == true) {
              this.displaySuspend = false
              this.router.navigateByUrl('/headers-by-pe');
              this.$modal.successModal({
                title: 'Header Suspension/ Revocation',
                msg: "Header has been suspended successfully"
              });
            }
            else if(r.msg == "Header is already in the provided status"){
              this.displaySuspend = false
              this.displayRevoke = true
              this.$modal.errorModal({
                title: 'Header Suspension/ Revocation',
                msg: r.msg
              });
              this.router.navigateByUrl('/headers-by-pe');
            }
            else {
              this.$modal.errorModal({
                title: 'Header Suspension/ Revocation',
                msg: r.msg
              });
            }
          })
      }
    })
  }
  }

  revokeHeader() {
    console.log("revoke")
    if(this.customerAffErr){
      this.$modal.errorModal({
        title: 'Header Suspension/ Revocation',
        msg: "Please select the checkbox to proceed"
      });
      return      
    }
    if(this.headerSuspForm.invalid){
       return
    }
    let currentsts = ""
    let stsexpnded = this.headerSuspForm.controls['status'].value 
    if(stsexpnded == "Active")
      currentsts = "A"
    else if (stsexpnded == "Suspended By customer")
      currentsts = "SC"
    else if (stsexpnded == "Suspended as Unused")
      currentsts = "SU"
    else if (stsexpnded == "Suspended due to Verification" ||  stsexpnded == "Suspended as Validity expired")
      currentsts = "SV"
    
    let data = {
      cli: this.headerSuspForm.controls['hname'].value,
      // sts: this.headerSuspForm.controls['status'].value,
      sts: "A",
      currentsts: currentsts,
      hid: this.headerSuspForm.controls['hid'].value,
      hclass: this.headerSuspForm.controls['hclass'].value,
      peid: this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID),
      orgname: this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME),    
      Email: this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID),    
      htype: this.htyp,
      urn: this.urn,
      reason:this.headerSuspForm.controls['description'].value
    }

    if(this.crtr == false){
      this.$modal.errorModal({
        title: 'Header Suspension/ Revocation',
        msg: "Only creator operator can suspend or revoke the header"
      });
      return
    }
    
    if(this.headerSuspForm.controls['hclass'].value == "Temporary"){
      console.log(this.headerSuspForm.controls['validityDays'].value)
      if(this.headerSuspForm.controls['validityDays'].value == undefined || this.headerSuspForm.controls['validityDays'].value == ""){
        this.$modal.errorModal({
          title: 'Header Suspension/ Revocation',
          msg: "Please select validity days"
        });
        return
      }
      else{
        console.log("Elsee ")
      data["validitydays"] = this.headerSuspForm.controls['validityDays'].value
      }
    }

    this.hs.revokeHeaderByPE(data)
      .subscribe(r => {
        if (r.status == true) {
          this.displayRevoke = false
          this.router.navigateByUrl('/headers-by-pe');
          let val = ""
          if(r.hclass == 'Temporary'){
             val = "Valid Till"
          }
          else if(r.hclass == "Permanent"){
             val = "Verified Till"
          }
          this.$modal.successModal({
            title: 'Header Suspension/ Revocation',
            msg: "Header has been revoked successfully with "+val +" " + r.validity
          });
        }
        else if(r.msg == "Header is already in the provided status"){
          this.displayRevoke = false
          this.displaySuspend = true
          this.$modal.errorModal({
            title: 'Header Suspension/ Revocation',
            msg: r.msg
          });
          this.router.navigateByUrl('/headers-by-pe');
        }
        else {
          this.$modal.errorModal({
            title: 'Header Suspension/ Revocation',
            msg: r.msg
          });
        }
      })
  }

  customeraffirmation(event){
		
		if(event.checked == true){
			this.customerAffErr = false;
		}
		else{
			this.customerAffErr = true;
		}	
	
	}



}
